import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

type InitialStateT = { currentRecommendationStep: number }

// const userInitial = {
//   auth: false,
//   firstName: '',
//   secondName: '',
//   email: '',
//   id: 0,
//   img: '',
// }

const initialState: InitialStateT = {
  currentRecommendationStep: 0,
  // user: userInitial,
}

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    confirmRecommendationStep: (state) => {
      state.currentRecommendationStep += 1

      return state
    },
  },
  extraReducers: (builder) => {},
})

export const { confirmRecommendationStep } = userSlice.actions

export default userSlice.reducer
